
(function () {

    'use strict';

    angular.module('iplusjs.utils.focusOnShow', [])
        .directive('iplusjsFocusOnShow', focusOnShow);

    focusOnShow.$inject = [
        '$timeout',
        '$document'
    ];
    function focusOnShow($timeout, $document) {
        return {
            restrict: 'A',
            priority: 0,
            link: function ($scope, $element, $attrs) {
                var focusJqLite = $attrs.ifosJqLite,
                    stateChangeSuccess = isStateChangeSuccess($attrs.ifosStateChangeSuccess);

                function isStateChangeSuccess(stateChangeSuccess) {
                    return angular.isDefined(stateChangeSuccess) ? stateChangeSuccess : true;
                }

                function focusElement() {
                    var focusEl,
                        activeElement = angular.element($document[0].activeElement),
                        activeElementNgNodelCtrl,
                        activeElementIsTouchedBeforeFocus = true;

                    if (focusJqLite) {
                        focusEl = $element.find(focusJqLite)[0];
                    } else {
                        focusEl = $element[0];
                    }

                    if (focusEl && angular.isFunction(focusEl.focus)) {
                        if (activeElement) {
                            activeElementNgNodelCtrl = activeElement.controller('ngModel');
                            activeElementIsTouchedBeforeFocus = !!activeElementNgNodelCtrl && activeElementNgNodelCtrl.$touched;
                        }

                        focusEl.focus();

                        if (activeElementNgNodelCtrl && !activeElementIsTouchedBeforeFocus) {
                            activeElementNgNodelCtrl.$setUntouched();
                        }
                    }
                }

                $scope.$watch($attrs.ifosStateChangeSuccess, function (newValue) {
                    stateChangeSuccess = isStateChangeSuccess(newValue);
                });

                $scope.$watchGroup([$attrs.ngShow, $attrs.ngIf], function (newValue) {
                    if ((newValue[0] || newValue[1]) && stateChangeSuccess) {
                        $timeout(function () {
                            focusElement();
                        }, 0);
                    }
                });
            }
        };
    }

})();
